<template>
  <div
    v-if="enableLiveEvents && addDrawer"
    id="LiveEventsComp"
    class="live-events-modal z-900"
  >
    <!-- Ovelay -->
    <transition name="fade">
      <div
        v-if="overlayLabels && overlayStyles"
        v-show="isOpen"
      >
        <button
          :class="`f-cover bg-${overlayStyles.bg_color || 'black'} opacity-${overlayStyles.opacity || 50}`"
          @click="$store.commit('liveEventsModalOpen')"
          :title="htmlDecode(overlayLabels.btn_title || 'Close live events')"
        />
      </div>
    </transition>
    <!-- Drawer -->
    <div
      id="lep-drawer" class="absolute right-0 top-0 w-full max-w-150 h-full z-1000 md:transition-transform duration-500 ease-in-out"
      :class="[isOpen ? 'transform-translate-x-0' : 'transform-translate-x-full']"
    >
      <div
        class="r-cover bg-white text-body"
      >
        <!-- Sidebar -->
        <transition name="fade">
          <div
            v-show="isOpen"
            class="relative w-full max-h-full scrolling-touch"
            @click="stopProp"
          >
            <div id="hook" />
          </div>
        </transition>
        <!-- Toggle -->
        <transition name="fade">
          <div class="absolute right-1/1 top-1/2 origin-top-right transform-rotate-z-90-translate-x-1/2 px-4 hidden md:flex-c">
            <button
              id="live-events-modal-toggle"
              :class="tbClasses"
              :title="htmlDecode(tbTitle)"
              :aria-label="htmlDecode(tbTitle)"
              @click="$store.commit('liveEventsModalOpen', !isOpen)"
            >
              <span
                :class="tbSpanClasses"
                v-html="toggleBtnLabels.btn_text"
              />
            </button>
          </div>
        </transition>
      </div>
    </div>
  </div>
  <div
    v-else-if="enableLiveEvents && !addDrawer"
    id="hook"
  />
</template>

<script>
import Aquarium from '@/assets/aquarium.esm.min.js'
import MultiBtn from '@/components/buttons/MultiBtn.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'LiveEvents',

  components: {
    Aquarium,
    MultiBtn
  },

  // Temporary while Stanga are creating their own drawer and toggles
  data: () => ({
    addDrawer: true
  }),

  computed: {
    ...mapState([
      'frontendUrl',
      'lteTablet',
      'liveEventsModalOpen'
    ]),
    ...mapGetters([ 'myStore' ]),
    lepOptions() { return this.myStore(['options', 'live_events']) ?? {} },
    isAdminEnabled() { return this.myStore(['settings', 'live_events_enabled']) ?? false },
    isClientEnabled() { return this.lepOptions.enabled ?? false },
    enableLiveEvents() { return this.isAdminEnabled && this.isClientEnabled },
    isOpen() { return this.liveEventsModalOpen ?? false },
    // Labels
    lepLabels() { return this.myStore(['labels', 'live_events']) ?? {} },
    overlayLabels() { return this.lepLabels.overlay ?? {} },
    // Styling
    lepStyles() { return this.myStore(['styles', 'live_events']) ?? {} },
    overlayStyles() { return this.lepStyles.overlay ?? {} },
    // Button
    // Data
    largeBtn() { return !this.lteTablet },
    // Button theme
    toggleBtnLabels() { return this.lepLabels.toggle_button ?? {} },
    toggleBtnStyles() { return this.lepStyles.toggle_button ?? {} },
    tbFocusStyles() { return this.toggleBtnStyles.focus ?? false },
    tbHoverStyles() { return this.toggleBtnStyles.hover ?? false },
    tbClasses() {
      const { largeBtn, toggleBtnStyles, tbFocusStyles, tbHoverStyles } = this
      if (!toggleBtnStyles || !tbFocusStyles || !tbHoverStyles) { return }
      // Dimensions
      const heightClasses = largeBtn ? 'min-h-12_5' : 'min-h-10_5'
      // Padding
      const px = largeBtn ? 'px-8' : 'px-6'
      const py = largeBtn ? 'py-2_25' : 'py-2_25'
      // Return
      return [
        // GTM
        `live-events-modal-${this.isOpen ? 'open' : 'closed'}`,
        // Group
        'group',
        // Position
        'relative',
        // Dimensiosn
        // Margin
        `mr-4 last:mr-0`,
        // Padding
        `${px} ${py}`,
        // Display
        'inline-flex items-center',
        // Borders
        `border-${toggleBtnStyles.border_width ?? 2} border-${toggleBtnStyles.border_color ?? 'black'}`,
        `focus:border-${tbFocusStyles.border_color ?? borderColor} lg:hover:border-${tbHoverStyles.border_color ?? borderColor}`,
        `rounded-b-${toggleBtnStyles.border_radius ?? 5}`,
        // Bg
        `bg-${toggleBtnStyles.bg_color}`,
        `focus:bg-${tbFocusStyles.bg_color} lg:hover:bg-${tbHoverStyles.bg_color}`,
        // Text
        `text-${toggleBtnStyles.text_color}`,
        `focus:text-${tbFocusStyles.text_color} lg:hover:text-${tbHoverStyles.text_color}`,
        // Outline
        'focus:outline-none',
        // Transitions
        'transition-colors duration-500 ease-in-out'
      ]
    },
    tbTitle() {
      return this.toggleBtnLabels.btn_title || this.toggleBtnLabels.btn_text
    },
    // Text
    tbSpanClasses() {
      const { toggleBtnStyles, largeBtn } = this
      if (!toggleBtnStyles) { return }
      // Font size
      const fontSizeClasses = largeBtn ? 'text-xl' : ''
      // return
      return [
        'w-full',
        fontSizeClasses,
        // Family
        `font-${toggleBtnStyles.font_family}`,
        // Weight
        `font-${toggleBtnStyles.font_family}-${toggleBtnStyles.font_weight}`,
        // Text transform
        toggleBtnStyles.text_transform ?? 'normal-case',
        // Ellipsis
        'truncate'
      ]
    },
  },

  mounted() {
    const { frontendUrl } = this
    const returnUrl = frontendUrl[0] === '/' ? `${window.location.origin}${frontendUrl}` : frontendUrl
    if (!this.enableLiveEvents) { return }
    Aquarium('oRVlAwDh4pDE9E0k8TtfALWjxobgfGPI', returnUrl).$mount('#hook')
  },

  methods: {
    stopProp(e) { e.stopPropagation() }
  }
}
</script>
